import { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { CalendarGroupItem } from './CalendarGroupItem'
import groupBy from 'lodash/groupBy'

import styles from '../../dive-center/DslMarineLifeCalendar/Calendar.module.scss'
import CalendarFilter from './CalendarFilter'
import NoResults from '../NoResults'
import CalendarLegend from './CalendarLegend'

const getOther = (data) => {
  return data.reduce((acc, el) => {
    const isOther = !['shark', 'whale', 'turtle'].some((cat) =>
      el.group.title.toLowerCase().includes(cat)
    )
    return isOther ? [...acc, el] : acc
  }, [])
}

const getFiltered = (data, filter) =>
  data.filter((el) =>
    el.group.title.toLowerCase().includes(filter.slice(0, -1))
  )

const CalendarContainer = ({ data }) => {
  const [filteredData, setFilteredData] = useState([])
  const [filterName, setFilterName] = useState('all')
  const [isHidden, setIsHidden] = useState(true)

  useEffect(() => {
    if(data) {
      data.forEach((el) => {
        if(!el.group) {
          el.group = {
            id: el.id,
            title: 'Others',
          }
        }
      })
      let filtered
      if(filterName === 'all') {
        filtered = data
      } else if(filterName === 'others') {
        filtered = getOther(data)
      } else {
        filtered = getFiltered(data, filterName)
      }
      const grouped = groupBy(filtered, 'group.title')
      setFilteredData(Object.values(grouped))
    }
  }, [filterName, data])

  useEffect(() => {
    setIsHidden(!window.marineLife || !window.marineLife.length)
  }, [filteredData.length])

  const handleFilter = (filterName) => {
    setFilterName(filterName)
  }

  return (
    <div className={styles.calendar}>
      <h3 className='do-section-title'>
        <FormattedMessage id='marine_life' defaultMessage='Marine Life' />
      </h3>
      <div className={styles.header}>
        <CalendarFilter handleFilter={handleFilter} isHidden={isHidden} />
        <CalendarLegend isHidden={isHidden} />
      </div>
      <div className={styles.calendarContainer}>
        {!filteredData.length ? (
          <NoResults />
        ) : (
          filteredData.map((group) => (
            <CalendarGroupItem key={group[0].group.id} group={group} />
          ))
        )}
      </div>
    </div>
  )
}

export default CalendarContainer
